import { Injectable } from '@angular/core';
import { WritableSignal, signal } from '@angular/core';import { ApiService } from '../api.service';
import { Observable } from 'rxjs';import { feedbackFormsData, runsDataByUserResponse, confirmationResponse} from '../../models/serviceModels/response/feedbackRes.model';
import { currentFeedbackModel, feedbackFormRequest, runsDataByUserRequest, givenFeedbackModel } from '../../models/serviceModels/request/feedbackReq.model';
import { openTradesRequestModel } from '../../models/serviceModels/request/openTradesReq.model';
import { OpenTrades } from '../../models/serviceModels/response/openTradesRes.model';
import { StandardDropdown } from '../../models/components/dropdowns/standardDropdown.models';

@Injectable({
    providedIn: 'root'
  })
  export class FeedbackService {

    private feedbackFormData: WritableSignal<feedbackFormsData | null> = signal(null);
    private runsDataByUser: WritableSignal<runsDataByUserResponse | null> = signal(null);
    private feedbackFormDataLoaded: WritableSignal<boolean> = signal(false);
    private areMandatoryFieldsLoaed: WritableSignal<boolean> = signal(false);
    private areFieldsDisabled: WritableSignal<boolean> = signal(false);


    private givenFeedbackResponse: WritableSignal<currentFeedbackModel | null> = signal(null);

    private selectedFeedbackType: StandardDropdown|null = null;

    constructor(private apiService: ApiService) { }

    getSelectedFeedbackType(): StandardDropdown|null {
        return this.selectedFeedbackType;
    }

    setSelectedFeedbackType(feedbackType: StandardDropdown): void {
        this.selectedFeedbackType = feedbackType;
    }

    getFieldsStatus(): boolean {
        return this.areFieldsDisabled();
    }

    setFieldsStatus(value: boolean): void {
        this.areFieldsDisabled.set(value);
    }
    
    getAreMandatoryFieldsLoaded(): boolean {
        return this.areMandatoryFieldsLoaed();
    }

    setAreMandatoryFieldsLoaded(value: boolean): void {
        this.areMandatoryFieldsLoaed.set(value);
    }
    

    getFeedbackBeforeSubmit(): currentFeedbackModel | null {
    
        return this.givenFeedbackResponse();
    }

    resetFeedbackValues(){
        this.givenFeedbackResponse.set(null);
    }

    setFeedbackValues(feedbackValues: currentFeedbackModel) {
        const currentFeedback = this.givenFeedbackResponse();
        const updatedFeedback = { ...currentFeedback, ...feedbackValues };
        this.givenFeedbackResponse.set(updatedFeedback);
    }

    getFeedbackFormData(feedbackFormRequest: feedbackFormRequest): Observable<feedbackFormsData> {
        return this.apiService.post('api/Data/GetFeedbackFormData', feedbackFormRequest);
    }

    getPredictionsByUser(runsDataByUserRequest:runsDataByUserRequest): Observable<runsDataByUserResponse> {
        return this.apiService.post('api/Data/GetPredictionsByUser', runsDataByUserRequest);
        //GetPredictionsByUser
    }

    sendFeedback(givenFeedback: givenFeedbackModel): Observable<confirmationResponse>{
        return this.apiService.post('api/Data/SubmitFeedback', givenFeedback);
    }

    setFormData(feedbackData: feedbackFormsData) {
        this.feedbackFormData.set(feedbackData);
        this.feedbackFormDataLoaded.set(true);
    }

    setRunsDataByUser(feedbackData: runsDataByUserResponse) {
        this.runsDataByUser.set(feedbackData);
    }

    getRunsDataByUser(): WritableSignal<runsDataByUserResponse | null> {
        return this.runsDataByUser;
    }

    getFormData(): WritableSignal<feedbackFormsData | null> {
        return this.feedbackFormData;
    }

    getOpenTrades(openTradesRequest: openTradesRequestModel): Observable<OpenTrades> {
        return this.apiService.post('api/Data/GetOpenTrades', openTradesRequest);
    }
    
  }